import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewSettings: {
		id: 'work-management-board.header.view-settings-panel.view-settings',
		defaultMessage: 'View settings',
		description: 'Title for button to open view settings panel.',
	},
	closeButtonLabel: {
		id: 'work-management-board.header.view-settings-panel.close-button-label',
		defaultMessage: 'Close',
		description: 'Label for close button in view settings panel.',
	},
	configureColumns: {
		id: 'work-management-board.header.view-settings-panel.configure-columns',
		defaultMessage: 'Configure columns',
		description: 'Label representing a menu button for configuring columns settings.',
	},
});
